import React from 'react'

import {
  numberAddCommas,
  allowNumericOnly,
  numberWithCommas,
  presenceErrorClass
} from 'servos/formValidations'

class ExpenseInputBox extends React.Component {
  disabledClass() {
    return (this.props.disabled ? 'disabled': '')
  }

  render() {
    const {
      id,
      onChange,
      value,
      errorMessage,
      disabled,
      type,
      inputMode,
      focusedInput,
      handleFocusedInput,
      handleBlurredInput,
    } = this.props

    const prependTextColor = focusedInput === id ? 'prepend-text-color' : ''
    return (
      <div className="input-box form-row">
        <div className="input-box__input-col col-8 col-sm-4">
          <div className={`input-group ${this.disabledClass()}`}>
            <div className="input-group-prepend">
              <div className={`input-group-text ${prependTextColor} ${presenceErrorClass(errorMessage)}`}>
                $
              </div>
            </div>
            <input
              placeholder='Enter monthly amount'
              type={ type ? type : 'text' }
              inputMode={ inputMode ? inputMode : 'text' }
              id={id}
              readOnly={ disabled }
              onKeyPress={allowNumericOnly}
              onKeyUp={numberWithCommas}
              className={`form-control ${presenceErrorClass(errorMessage)}`}
              value={numberAddCommas(value)}
              onFocus={() => handleFocusedInput(id)}
              onBlur={() => handleBlurredInput()}
              onChange={onChange} 
            />

          </div>
        </div>
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

export default ExpenseInputBox;
